import * as actionTypes from './cloneSchedule.actionTypes';

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_CREATED_SEGMENTS_ERROR:
      return action.payload;
    case actionTypes.FETCH_CREATED_SEGMENTS_SUCCESS:
      return action.payload.segmentList.map(segment => {
        return {
          ...segment,
          label: segment.segmentName,
          value: segment.uuid,
        };
      });
    default:
      return state;
  }
}
